export default {
    setProductosCatalogo(state, payload) {
        let findIndex = state.productosCatalogos.findIndex(pc => pc.catalogo == payload.catalogo);
        if (findIndex > -1) {
            state.productosCatalogos[findIndex].productos = payload.productos;
            state.productosCatalogos[findIndex].tarifa = payload.tarifa;
        } else {
            state.productosCatalogos.push({
                catalogo: payload.catalogo,
                productos: payload.productos,
                tarifa: payload.tarifa
            })
        }
    },
    setCategoriaFiltrar(state, c) {
        state.categoriaFiltrar = c;
    },
    setGenerarCatalogo(state, b) {
        state.generarCatalogo = b
    },
    setGenerarCatalogoObj(state, obj) {
        state.generarCatalogoObj = obj
    },
    setGenerarCatalogoObjValor(state, payload) {
        state.generarCatalogoObj[payload.key] = payload.value
    },
    resetGenerarCatalogoObj(state) {
        state.generarCatalogoObj = {
            negocio: false,
            restaurantes: [],
            catalogos: [],
            productos: []
        }
    },
    setLoadingGenerarCatalogos(state, b) {
        state.loadingGenerarCatalogos = b;
    },
    setGenerarAutomaticos(state, b) {
        state.generarAutomaticos = b;
    }
}